const textosInitialState = {
    textos: {
      loading: false,
      error: null,
      data: null,
    },
  };
  
  export default textosInitialState;